import React from 'react';
import classes from './Modal.module.css';

const Backdrop = (props) => {
  return <div className={props.popup ? classes.backdropPopup : classes.backdrop} {...props}/>;
}

export default Backdrop;